import {DomainEvent} from "@platform/event-bus/domain/model/domain-event.model";

export class WaiterSessionEndedEvent implements DomainEvent {
  readonly occurredAt = new Date();

  constructor() {
  }
}
